module.exports = __webpack_public_path__ + "img/logo-dark-medium.7356a3b2.png";